<template>
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6.5" cy="6.5" r="5.5" stroke="url(#paint0_linear_627_5895)" />
    <path
      d="M6.50038 4.15642C6.72436 4.15642 6.90594 3.97485 6.90594 3.75087C6.90594 3.52689 6.72436 3.34531 6.50038 3.34531C6.2764 3.34531 6.09482 3.52689 6.09482 3.75087C6.09482 3.97485 6.2764 4.15642 6.50038 4.15642Z"
      fill="url(#paint1_linear_627_5895)"
      stroke="url(#paint2_linear_627_5895)"
      stroke-width="0.2"
    />
    <path d="M6.5 9.55512V5.27734" stroke="url(#paint3_linear_627_5895)" />
    <defs>
      <linearGradient
        id="paint0_linear_627_5895"
        x1="6.5"
        y1="1"
        x2="6.5"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_627_5895"
        x1="6.50038"
        y1="3.44531"
        x2="6.50038"
        y2="4.05642"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_627_5895"
        x1="6.50038"
        y1="3.44531"
        x2="6.50038"
        y2="4.05642"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_627_5895"
        x1="7"
        y1="5.27734"
        x2="7"
        y2="9.55512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
